import { css } from '@mvf/product-components';

const subcategoryDivisionPickerStyles = theme => ({
  search: css({
    padding: `0 ${theme.mvf.spacing.small}`,
  }),
});

export default subcategoryDivisionPickerStyles;
